import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./styles/theme.css";
import Sidebar from "./components/Sidebar";
import Dashboard from "./pages/Dashboard";
import Users from "./pages/Users";
import Products from "./pages/Products";
import Orders from "./pages/Orders";
import Community from "./pages/Community";
import Reports from "./pages/Reports";
import Notifications from "./pages/Notifications";
import HairTips from "./pages/HairTips";
import { Reviews, Complaints, ZoraData } from "./pages/OtherPages";
import Login from "./pages/Login";
import Blogs from "./pages/Blog";
import AuthGuard from "./components/AuthGuard";
import Waitlist from "./pages/Waitlist";
import Ads from "./pages/Ads";
import AuditLog from "./pages/AuditLog";
import Discounts from "./pages/Discounts";
import { AdminAuthProvider } from "./context/AdminAuth";
import { ToastProvider } from "./components/ui/Feedback";

// Layout wrapper — sidebar + main content
function AdminLayout({ children }: { children: React.ReactNode }) {
  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      <Sidebar />
      <main
        className="app-main"
        style={{
          marginLeft: 240,
          flex: 1,
          minHeight: "100vh",
          width: "calc(100% - 240px)",
          overflowX: "hidden",
        }}
      >
        {children}
      </main>
    </div>
  );
}

export default function App() {
  return (
    // AdminAuthProvider sits above the router so the identity survives
    // navigation instead of being re-fetched by each page that needs it.
    // ToastProvider sits above everything so a failure raised inside a drawer
    // still has somewhere to render.
    <BrowserRouter>
      <AdminAuthProvider>
        <ToastProvider>
      <Routes>
        {/* Public route */}
        <Route path="/login" element={<Login />} />

        {/* Protected routes — AuthGuard wraps the layout */}
        <Route
          path="/*"
          element={
            <AuthGuard>
              <AdminLayout>
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/users" element={<Users />} />
                  <Route path="/products" element={<Products />} />
                  <Route path="/orders" element={<Orders />} />
                  <Route path="/community" element={<Community />} />
                  <Route path="/reports" element={<Reports />} />
                  <Route path="/waitlist" element={<Waitlist />} />
                  <Route path="/ads" element={<Ads />} />
                  <Route path="/notifications" element={<Notifications />} />
                  <Route path="/blog" element={<Blogs />} />
                  <Route path="/hair-tips" element={<HairTips />} />
                  <Route path="/zora" element={<ZoraData />} />
                  <Route path="/reviews" element={<Reviews />} />
                  <Route path="/discounts" element={<Discounts />} />
                  <Route path="/audit" element={<AuditLog />} />
                  <Route path="/complaints" element={<Complaints />} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </AdminLayout>
            </AuthGuard>
          }
        />
      </Routes>
        </ToastProvider>
      </AdminAuthProvider>
    </BrowserRouter>
  );
}